import { useState, useEffect } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { 
  Box, 
  Stack, 
  Typography, 
  Paper,
  Fab, 
  Table,
  TableRow,
  TableHead, 
  TableContainer,
  TableBody,
  TableCell,
  IconButton,
  Button,
  Grid,
  useTheme
} from '@mui/material';
import TimeAgo from 'javascript-time-ago';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useLocation } from 'react-router';
import { AlertMessage } from '../messages/AlertMessage';
import { ReportEntry } from './ReportEntry';

const ReportPage = (props) =>  {

  const { state } = useLocation();
  const theme = useTheme();

  const [rows, setRows] = useState([]);
  
  const getAllReports = () => {
    const requestOptions = {
        method: 'GET'
    };
    
    fetch('/api/reports', requestOptions)
    .then(r => r.json())
    .then(res => {
        setRows(res);
    })
    .catch(err => {
        console.error(err);
    });
  };

  const handleDelete = (id) => {
    const requestOptions = {
        method: 'DELETE'
    };
    fetch('/api/report/'+id, requestOptions)
    .then(r => getAllReports())
    .catch(err => console.error(err));
  };

  useEffect(() => {
    getAllReports();
  }, []);

  const timeAgo = new TimeAgo('de');

  return (
    <Box sx={{ flexGrow: 1, marginTop: '10px !important' }}>
      <Box sx={{ overflow: "auto" }}>
        <Box sx={{ width: "100%", boxSizing: 'border-box', display: "table", tableLayout: "fixed" }}>
          <AlertMessage severity={'success'} message={state?.message} />
          <Stack direction="row" spacing={2} sx={{ flexGrow: 1, margin: '20px', alignItems: 'center' }}>
            <Typography variant="h6" component="div">
              Erfahrungsberichte
            </Typography>
            <Fab href="/report/add" size="medium" color="primary" aria-label="add">
              <AddIcon />
            </Fab>
          </Stack>
          {rows?.length === 0 && 
            (<Box sx={{ marginTop: '20px !important', marginBottom: '20px !important' }}>
              <Typography sx={{marginLeft: '20px !important'}} variant="body2">
                Du besitzt noch keine Erfahrungsberichte. Erstelle deinen ersten Erfahrungsbericht.
              </Typography>
              <Button className="custom-button-root" href="/report/add">Erfahrungsbericht erstellen</Button>
            </Box>)}
          <TableContainer sx={{display: { xs: 'none', md: 'block' }, marginX: "20px", width: 'auto', minWidth: 'unset !important', backgroundColor: theme.palette.primary.main}} component={Paper}>
            <Table stickyHeader size="small" aria-label="a dense table">
                {!!rows.length > 0 &&<TableHead>
                <TableRow>
                    <TableCell className="custom-table-header-root" align="left">Zeitpunkt</TableCell>
                    <TableCell className="custom-table-header-root">Produkt</TableCell>
                    <TableCell className="custom-table-header-root" align="left">Dauer</TableCell>
                    <TableCell className="custom-table-header-root" align="left">Temperatur</TableCell>
                    <TableCell className="custom-table-header-root" align="left">Krossheits-Level</TableCell>
                    <TableCell className="custom-table-header-root" align="left">Krossheits-Level innen</TableCell>
                    <TableCell className="custom-table-header-root" align="left">Aktionen</TableCell>
                </TableRow>
                </TableHead>}
                <TableBody>
                {!!rows && rows?.map((row) => (
                    <TableRow
                    key={row?.timestamp}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="left">{timeAgo.format(new Date(row?.timestamp))}</TableCell>
                      <TableCell component="th" scope="row">
                          {row?.product?.name}
                      </TableCell>
                      <TableCell align="left">{row?.duration} Minuten</TableCell>
                      <TableCell align="left">{row?.temperature} °C</TableCell>
                      <TableCell align="left">{row?.crispyness?.label}</TableCell>
                      <TableCell align="left">{row?.innerCrispyness?.label}</TableCell>
                      <TableCell align="left">
                        <Stack direction="row" spacing={2} sx={{ flexGrow: 1, alignItems: 'center' }}>
                          <IconButton href={"/report/edit/"+row?.id} size="small" color="secondary" aria-label="edit">
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton onClick={(event)=> handleDelete(row?.id)} size="small" color="error" aria-label="delete">
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Stack>
                      </TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
          </TableContainer>
          <Grid 
            container
            direction="row"
            sx={{
              display: { xs: 'flex', md: 'none' },
              marginTop: '20px',
              alignItems: "stretch",
            }} 
            spacing={4}
          >
            {!!rows && rows?.map((row) => <ReportEntry
              id={row?.id} 
              productName={row?.product?.name}
              temperature={row?.temperature}
              duration={row?.duration}
              crispyness={row?.crispyness?.label}
              innerCrispyness={row?.innerCrispyness?.label}
              handleChangeSearch={getAllReports}  />)}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}


export default ReportPage;
